import { render, staticRenderFns } from "./ItemsOrderServiceItem.vue?vue&type=template&id=08462668&scoped=true&"
import script from "./ItemsOrderServiceItem.vue?vue&type=script&lang=js&"
export * from "./ItemsOrderServiceItem.vue?vue&type=script&lang=js&"
import style0 from "./ItemsOrderServiceItem.vue?vue&type=style&index=0&id=08462668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08462668",
  null
  
)

export default component.exports